import React, { Component } from 'react';
import { Container, Table, Button, Modal, Card, Spinner,Input } from 'react-bootstrap';
import { Link, withRouter } from 'react-router-dom';
import axios from 'axios';

import auth from '../../functions/auth';
import { NavBar, Loading, AdminNav } from '../../helpers';

class AdminSys extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Company: {},
      Officer: {},
      // Rice: {},
      user: {
        name: 'admin',
        role: 'admin',
      },
      showModal : false

    };
    this.renderRiceType = this.renderRiceType.bind(this)
    this.handleTitleClick = this.handleTitleClick.bind(this)
    this.handleRegister = this.handleRegister.bind(this)
    this.handleClickRegister = this.handleClickRegister.bind(this)
    this.renderModal = this.renderModal.bind(this)
    this.handleCloseModal = this.handleCloseModal.bind(this)
    this.handleShowModal = this.handleShowModal.bind(this)
  }

  componentDidMount() {
    console.log('come')
    let viewAllCompany = fetch('https://backend1.riceinspections.com/testD').then((res) => {
      return res.json()
    })

    let viewAllOfficer = fetch('https://backend1.riceinspections.com/testC').then((res) => {
      return res.json()
    })

    let viewAllRice = fetch('https://backend1.riceinspections.com/testE').then((res) => {
      return res.json()
    })

    let viewAllSurvey = fetch(`https://backend1.riceinspections.com/testBD`).then((res) => {
      return res.json()
    })
    let viewAllUser = fetch(`https://backend1.riceinspections.com/viewalluser`).then((res) => {
      return res.json()
    })

    Promise.all([viewAllCompany, viewAllOfficer, viewAllRice, viewAllSurvey,viewAllUser]).then((res) => {
      console.log(res[4])
      this.setState({
        ...this.state,
        Company: res[0],
        Officer: res[1],
        rice: res[2],
        Survey: res[3],
        user : res[4]['data']
      })
    })

  }
  renderRiceType() {
    if (this.state.rice) {
      // console.log(this.state.rice)
      return (
        Object.values(this.state.rice).map((a, idx) => {
          if (idx <= 10) {
            return <tr ><td>{a['riceTypeName']}</td><td>{a['riceTypeID']}</td></tr>
          }
        })
      )
    }
  }
  renderCompany() {
    if (this.state.Company) {
      // console.log(this.state.rice)
      return (
        Object.values(this.state.Company).map((a, idx) => {
          if (idx <= 10) {
            return <tr ><td>{a['companyNameTH']}</td><td>{a['companyNameEN']}</td></tr>
          }
        })
      )
    }
  }
  renderSurvey() {
    if (this.state.Survey) {
      return (
        Object.values(this.state.Survey).map((a, idx) => {
          if (idx <= 10) {
            return <tr ><td>{a['surveyNameTH']}</td><td>{a['surveyNameEN']}</td></tr>
          }
        })
      )
    }
  }
  renderUser() {
    if (this.state.user) {
      console.log(this.state.user['users'])
      return (
        Object.values(this.state.user['users']).map((a, idx) => {
          if (idx <= 10) {
            return <tr><td>{a['email'].split('@')[0]}</td><td><Button variant='danger'> ลบผู้ใช้ </Button></td></tr>
          }
        })
      )
    }
  }


  Logout = () => {
    auth.logout(() => {
      this.props.history.push('/');
    })
  }

  handleTitleClick = (path, data) => {
    this.props.history.push({
      pathname: `/${path}`,
      state: data,
    })
  }
  renderModal = () => {
    return (
      <Modal
        show={this.state.showModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            เพิ่มผู้ใช้
        </Modal.Title>

        </Modal.Header>
        <Modal.Body>
            <span className="input-group-text"> ชื่อผู้ใช้ </span><input onChange={this.handleRegister} id='username' type="text" className="form-control" ></input>
            <span className="input-group-text">รหัสผ่าน</span> <input onChange={this.handleRegister} id='password' type="password" className="form-control"></input>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={this.handleCloseModal}>ปิด</Button>
          <Button variant="success" onClick={this.handleClickRegister}>ยืนยัน</Button>
        </Modal.Footer>
      </Modal >

    )
  }
  handleRegister = (e)=>{
    this.setState({
      ...this.state,
      [e.target.id] : e.target.value
    })
  }
  handleClickRegister = (e)=>{
    console.log(this.state)
    let login = axios.post(
      'https://backend1.riceinspections.com/register',
      {
        data: {
          'username': `${this.state.username}@gmail.com`,
          'password': this.state.password
        }
      } 
    ).then((data)=>{
      if(data['data']){
        let viewAllUser = fetch(`https://backend1.riceinspections.com/viewalluser`).then((res) => {
          return res.json()
        })    
        viewAllUser.then((res)=>{
          this.setState({
            ...this.state,
            showModal : false,
            user : res['data']
          })
        })
      }else{
        alert('ลงทะเบียนไม่สำเร็จ')
      }
    })
  }
  handleShowModal = ()=>{
    this.setState({
      ...this.state,
      showModal : true
    })
  }
  handleCloseModal = ()=>{
    this.setState({
      ...this.state,
      showModal : false
    })
  }

  render() {
    let { rice, Officer, Company } = this.state;
    if (!rice || !Officer || !Company) {
      return (
        <Container className="Admin">
          <NavBar />
          <Loading />
        </Container>
      )
    }
    return (
      <Container className="Admin">
        <AdminNav></AdminNav>
        <NavBar />

        <a href="#">
          <h5 onClick={this.handleShowModal}>เพิ่มผู้ใช้</h5>
        </a>
        {this.renderModal()}
        <Table bordered hover>
          <thead>
            {<tr><th>ชื่อผู้ใช้</th><th>ลบผู้ใช้</th></tr>}
          </thead>
          <tbody>
          {this.renderUser()}
          </tbody>
        </Table>

        <a href="#" onClick={() => { this.handleTitleClick('EditRice', this.state.rice) }}>
          <h3 >ชนิดข้าว</h3>
        </a>
        <Table bordered hover>
          <thead>
            {<tr><th>ชื่อข้าวภาษาไทย</th><th>ชื่อข้าวภาษาอังกฤษ</th></tr>}
          </thead>
          <tbody>
            {this.renderRiceType()}
          </tbody>
        </Table>

        <a href="#">
          <h3 onClick={() => { this.handleTitleClick('EditCompany', this.state.Company) }}>ชื่อบริษัท</h3>
        </a>
        <a href="#">
          <h5 onClick={() => { this.handleTitleClick('AddCompany', this.state.Company) }}>เพิ่มบริษัท</h5>
        </a>

        <Table bordered hover>
          <thead>
            {<tr><th>ชื่อบริษัทภาษาไทย</th><th>ชื่อบริษัทภาษาอังกฤษ</th></tr>}
          </thead>
          <tbody>
            {this.renderCompany()}
          </tbody>
        </Table>

        <a href="#" onClick={() => { this.handleTitleClick('EditSurvey', this.state.Survey) }}>
          <h3 >ชื่อสถานที่</h3>
        </a>
        <a href="#">
          <h5 onClick={() => { this.handleTitleClick('AddSurvey', this.state.Survey) }}>เพิ่มสถานที่</h5>
        </a>

        <Table bordered hover>
          <thead>
            {<tr><th>ชื่อสถานที่ภาษาไทย</th><th>ชื่อสถานที่ภาษาอังกฤษ</th></tr>}
          </thead>
          <tbody>
            {this.renderSurvey()}
          </tbody>
        </Table>

      </Container>
    );
  }
}

export default withRouter(AdminSys);
